import { fetcher } from '@commenda/utils';
import { UpdateSecureInformationRequestTemplateArgs } from './types';

export async function updateSecureInformationRequestTemplate(
  secureInformationRequestTemplateId: string,
  body: UpdateSecureInformationRequestTemplateArgs,
  token: string | undefined
) {
  const response = await fetcher(
    `secureInformationRequestTemplate/${secureInformationRequestTemplateId}`,
    {
      method: 'PUT',
      body,
    },
    token
  );

  return response;
} 